import { useWaiterTickets } from "context/WaiterTicketContext";
import { useMutation, useQuery } from "react-query";
import { useAuth } from "context/AuthContext";
import { useEffect, useState } from "react";
import { queryClient } from "App";

import api from "services/api";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";

export default function useWppAlert() {
  const { user } = useAuth();
  const { waiterTickets } = useWaiterTickets();
  const [isOpenWppAlertList, updateOpenWppAlertList] = useState(false);
  const location = useLocation();

  const queryKey = ['restaurant-alert-wpp', user?.id];

  const { data: wppAlertList } = useQuery({
    queryKey, 
    queryFn: () => api.get('/restaurants/help-requests/wpp').then(response => response.data),
    enabled: location.pathname === "/delivery/orders"
  });

  function handleThrowoutHelpRequest() {
    queryClient.setQueryData(queryKey, (state = []) => {
      const updatedState = state.map(item => {
        const { type, ...updatedItem } = item;
        return updatedItem;
      });
      return updatedState;
    });
  }
  
  const { mutate: handleCheckHelpRequests } = useMutation({
    mutationFn: (id) => api.put(`/restaurants/help-requests/wpp/${id}`).then(res => res.data),
    onSuccess(data) {
      queryClient.setQueryData(queryKey, (state = []) => {
        return state.map(item => {
          if (item.id !== data.id) return item;
          return {
            ...item,
            checked: true
          };
        });
      });
    }
  });

  const { mutate: handleDeleteCheckedHelpRequests } = useMutation({
    mutationFn: () => api.delete(`/restaurants/help-requests/wpp`),
    onSuccess() {
      queryClient.setQueryData(queryKey, (state = []) => {
        return state.filter(element => !element.checked);
      });
    },
  });

  useEffect(() => {
    if (!waiterTickets) return;

    const filteredWaiterTickets = waiterTickets.filter(ticket => ticket?.type === 'wpp-human-request');

    queryClient.setQueryData(queryKey, (state = []) => {
      const updatedState = [...state];

      filteredWaiterTickets.forEach(ticket => {
        if (!updatedState.some(alert => alert.id === ticket.id)) {
          updatedState.push(ticket);
        }
      });

      return updatedState;
    });
  }, [waiterTickets]);

  function handleCloseWppAlertModal(id) {
    queryClient.setQueryData(state => {
      return state.filter(element => element.id === id);
    });
  }

  function handleRedirectToWpp(phone, id) {
    handleThrowoutHelpRequest(id);
    const whatsappUrl = `https://wa.me/${phone}`;
    window.open(whatsappUrl, "_blank");
  }

  const checkedWppAlertList = 
    wppAlertList?.filter(alertElement => alertElement.checked)
    .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
  const uncheckedWppAlertList = 
    wppAlertList?.filter(alertElement => !alertElement.checked)
    .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
  const currentWppAlert = uncheckedWppAlertList && uncheckedWppAlertList?.find(alertElement => 
    alertElement.type === 'wpp-human-request'
  );

  return {
    checkedWppAlertList,
    uncheckedWppAlertList,
    currentWppAlert,
    isOpenWppAlertList,
    updateOpenWppAlertList,
    handleCheckHelpRequests,
    handleCloseWppAlertModal,
    handleThrowoutHelpRequest,
    handleRedirectToWpp,
    handleDeleteCheckedHelpRequests
  }
}